import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import missing_image from "./../../i/missing_image.svg";

import {
  sortNumeric,
  selectFormat,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";

export const CellTextImage = (cell, row, rowIndex, opts) => {
  // Image
  let IMAGE = { backgroundImage: `url(${missing_image})` };
  if (row.logo_url == null) {
    IMAGE = { backgroundImage: `url(${missing_image})` };
  } else {
    IMAGE = { backgroundImage: `url(${row.logo_url.replace(/'/g, "%27")})` };
  }

  // Title
  let TITLE = "";
  if (row.app_channel !== null && row.app_channel !== "") {
    TITLE = <h1 className="content-table__title">{row.app_channel}</h1>;
  } else {
    TITLE = "";
  }

  return (
    <article className="content-table">
      <figure className="content-table__figure">
        <div className="content-table__img" style={IMAGE} />
      </figure>

      <section className="content-table__detail">{TITLE}</section>
    </article>
  );
};

class HearstPublishers extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "app_channel",
        text: "App Channel",
        style: { width: "100px", minWidth: "100px" },
        sort: true,
        formatter: CellTextImage,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },

      {
        dataField: "video_impressions",
        text: "Video Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_views_complete",
        text: "Video Complete Views",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_completion_rate",
        text: "Completion Rate",
        style: { width: "100px", minWidth: "100px" },
        formatExtraData: { type: "percentage" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "display_impressions",
        text: "Display Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ctv_impressions",
        text: "CTV Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "mdt_impressions",
        text: "MDT Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "ctv_impressions",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{ fileName: filename + ".csv" }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default HearstPublishers;
